/**
 * NOTE: Native-only
 */
export function handleHardwareBackButtonPress(_callback: () => void) {
  return {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    removeListener() {},
  };
}
